import axios from 'axios';

const publicApi = axios.create({
	baseURL: `${process.env.REACT_APP_API_URL}/api`,
	headers: {
		'Content-Type': 'application/json',
		'ngrok-skip-browser-warning': 'true',
	},
});

export const getPublicPricing = () => publicApi.get('/public/pricing');
